import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import BackButton from '../components/ui/BackButton';
import ManageClassForm from '../components/admin/ManageClassForm';
import { PageContainer } from '../components/ui/StyledComponents';

function AdminManageClassPage() {
  const { classId } = useParams();
  const navigate = useNavigate();

  const handleSuccess = () => {
    // Navigate back to the classes list after successful update
    navigate('/admin/classes');
  };

  return (
    <PageContainer>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center' }}>
        <BackButton label="Back to Classes" />
        <Typography variant="h4">Manage Class</Typography>
      </Box>
      <ManageClassForm classId={classId} onSuccess={handleSuccess} />
    </PageContainer>
  );
}

export default AdminManageClassPage; 